export default __webpack_public_path__ + "d4dc11891cd5b27ca5aed0ec800b7710.svg";